/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempEditorWrapText: {
  name: 'temp-editor-wrap-text';
  data: string;
} = {
  name: 'temp-editor-wrap-text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 .5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H1ZM.5 7a.5.5 0 0 1 .5-.5h11a3.5 3.5 0 1 1 0 7h-1.793l1.147 1.146a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708.708L10.207 12.5H12a2.5 2.5 0 0 0 0-5H1A.5.5 0 0 1 .5 7Zm0 6a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
